import { Injectable } from '@angular/core';

import { Headers } from '@angular/http';

@Injectable()
export class Configuration {
    Server: string = 'http://165.227.152.243:3000/';
    ApiUrl: string = 'api/v1/';
    Url = this.Server + this.ApiUrl;

    authPassword = '&jno-@8az=wSo*NHYVGpF^AQ?4yn36ZvW5ToUCUN+XGOuC?sz#SE$oxXVbwQGP|3WFyjcTAj2SIRQnLE|vo^-|-ATV5FZUf2*5A3Oiu|_EOMmG==&iApzQL3R7HHQj?jtb0mc2mT$Y%Isrgrxveld#Z^g3-ul^|0xAITganIuF23J0waSa6z6aP_+%De5LqtuY&ptx?qhZySECdyE^*4R^b*hFjQ-9?cCSJNfROzztEYbRyN=SqDyhhpzSmmP|Eb';
    bodyAuth = '^*aNJW=#u*xrV+U^Z@3eLJTm&w@p&hWLA8T2X=Br%*+-Vqb^pgVZ$Km?sRRB7-Dfx!bkgc*L&7$Ad&x-rttNU!$65t9hbgQTT?YLSum#3jZB@5KbLhhwDwAND%hxEFMF';
    auth = 'Basic ' + new Buffer("basicAuth:" + this.authPassword).toString('base64');

    token = localStorage.getItem('user') || '';

    headers = new Headers({ 'Content-Type': 'application/json' });

    constructor() {
        this.headers.append('token', this.token);
        this.headers.append('authorization', this.auth);
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.constants.ts
 **/